export default "__VITE_ASSET__bsiw2Bii__"